import { render, staticRenderFns } from "./WarningAndCollectSheet.vue?vue&type=template&id=c45ed042&scoped=true&"
import script from "./WarningAndCollectSheet.vue?vue&type=script&lang=js&"
export * from "./WarningAndCollectSheet.vue?vue&type=script&lang=js&"
import style0 from "./WarningAndCollectSheet.vue?vue&type=style&index=0&id=c45ed042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45ed042",
  null
  
)

export default component.exports